import { useEffect, useState } from 'react';
import { getMSDRemoteBaseUrl, loadModuleV2 } from '../config/module-federation-config';

export enum InvestmentProductStatus {
  LOADING = 'loading',
  ERROR = 'error',
  DONE = 'done',
}

export function useModularOfferingFastTrackElement(enabled: boolean) {
  const [status, setStatus] = useState<InvestmentProductStatus>(InvestmentProductStatus.LOADING);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async function () {
      try {
        if (getMSDRemoteBaseUrl() !== '') {
          await loadModuleV2('modularoffering', getMSDRemoteBaseUrl(), 'modular-offering-fast-track-element', 'var');
          await customElements.whenDefined('iap-modular-offering-fast-track-element');

          setStatus(InvestmentProductStatus.DONE);
          return;
        }
        setStatus(InvestmentProductStatus.ERROR);
      } catch (e) {
        console.error(e);
        setStatus(InvestmentProductStatus.ERROR);
      }
    })();
  }, [enabled]);

  return status;
}
